const LineKeyType = Object.freeze({
  EMPTY: 0,
  FORWARD: 2,
  CALL_PARK: 10,
  DTMF: 11,
  SPEED_DIAL: 13,
  LINE: 15,
  BLF: 16,
  URL: 17,
  OPEN_DOOR: 84,
  VIDEO_MONITORING: 85,
  PAGINATION: 1001,
  FLEX_DESK: 1002,
});

export default LineKeyType;
